<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Szkolenia'" [name]="'Szkoleniowcy'"></app-breadcrumb>
<div class="idd-training-trainer-list-container" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div [fxFlex]="'100'" fxLayout="column" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Dane</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Imię</mat-label>
              <input [required]="true" matInput placeholder="Imię" [formControl]="firstNameControl">
            </mat-form-field>
          </div>

          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Nazwisko</mat-label>
              <input [required]="true" matInput placeholder="Nazwisko" [formControl]="lastNameControl">
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
<!--          <div fxFlex="100">-->
<!--            <mat-form-field fxFlex="100">-->
<!--              <mat-label>Wykształcenie</mat-label>-->
<!--              <input [required]="true" matInput placeholder="Imię" [formControl]="educationControl">-->
<!--            </mat-form-field>-->
<!--          </div>-->

          <div fxFlex="100">
            <mat-form-field fxFlex="100">
              <mat-label>Wykształcenie</mat-label>
              <textarea
                matInput
                [required]="true"
                placeholder="Wykształcenie"
                [formControl]="educationControl"
                maxlength="250"
                (input)="updateCharCountEducation()"
                matAutosize
              ></textarea>
              <mat-hint align="end">{{ charCountEducation }}/250</mat-hint>
            </mat-form-field>
          </div>

        </div>

        <div fxLayout="row" fxLayoutGap="15px">

<!--          <div fxFlex="100">-->
<!--            <mat-form-field fxFlex="100">-->
<!--              <mat-label>Doświadczenie</mat-label>-->
<!--              <input [required]="true" matInput placeholder="Nazwisko" [formControl]="experienceControl">-->
<!--            </mat-form-field>-->
<!--          </div>-->
<!--        </div>-->

        <div fxFlex="100">
          <mat-form-field fxFlex="100">
            <mat-label>Doświadczenie</mat-label>
            <textarea
              matInput
              [required]="true"
              placeholder="Doświadczenie"
              [formControl]="experienceControl"
              maxlength="250"
              (input)="updateCharCountExperience()"
              matAutosize
            ></textarea>
            <mat-hint align="end">{{ charCountExperience }}/250</mat-hint>
          </mat-form-field>
        </div>
    </div>

        <div fxLayout="row" fxLayoutGap="15px">

          <div fxFlex="100">
            <mat-form-field fxFlex="100">
              <mat-label>Notatka</mat-label>
              <input [required]="false" matInput placeholder="Notatka" [formControl]="memoControl">
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row"   fxLayoutGap="15px">
          <mat-slide-toggle color="accent" [formControl]="activeControl"> Aktywny</mat-slide-toggle>
        </div>


      </mat-card>

      <div fxLayout="row" fxLayoutGap="15px">
        <button (click)="save()" [class.spinner]="processingRequest"
                [disabled]=" processingRequest"
                mat-stroked-button color="primary">
          <mat-icon>save</mat-icon>
          <span> Zapisz</span></button>
        <button (click)="cancel()" mat-stroked-button color="warn">
          <mat-icon>cancel</mat-icon>
          <span> Anuluj</span></button>
      </div>
    </div>
  </div>
</div>
